// The event videos page's sort orders. The page already holds every video of
// the event in one live listener, so sorting is done here rather than by a
// query, and needs no index per order.

export const VIDEO_SORTS = ['createdDesc', 'createdAsc', 'durationDesc', 'durationAsc', 'challenge']

// A video written a moment ago carries a pending serverTimestamp (null) until
// the server answers; it is the newest, not the oldest.
const createdMs = (v) => (v.createdAt?.seconds != null ? v.createdAt.seconds * 1000 : Infinity)

// Only `originalDuration` — the recorded length, not the trimmed one. A video
// without it sorts last in either direction.
const durationOf = (v) => {
  const d = Number(v.originalDuration)
  return Number.isFinite(d) && d > 0 ? d : null
}

const challengeOf = (v) => String(v.challengeLabel || v.challenge || '')

const byDuration = (dir) => (a, b) => {
  const da = durationOf(a)
  const db = durationOf(b)
  if (da === null || db === null) return (da === null) - (db === null)
  return (da - db) * dir
}

const newestFirst = (a, b) => createdMs(b) - createdMs(a)

const COMPARATORS = {
  createdDesc: newestFirst,
  createdAsc: (a, b) => createdMs(a) - createdMs(b),
  durationDesc: byDuration(-1),
  durationAsc: byDuration(1),
  // Grouped by challenge, newest first within each.
  challenge: (a, b) =>
    challengeOf(a).localeCompare(challengeOf(b), undefined, { sensitivity: 'base' }) || newestFirst(a, b),
}

/**
 * @param {Array} videos
 * @param {string} sort One of VIDEO_SORTS; anything else is newest first.
 * @returns {Array} A sorted copy.
 */
export function sortVideos(videos, sort) {
  return [...videos].sort(COMPARATORS[sort] || newestFirst)
}
